import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface Players {
  id: number;
  name: string;
  profile_picture: string;
}

interface TournamentPlayersState {
  players: Players[];
  tournamentId: number | null;
}

const initialState: TournamentPlayersState = {
  players: [],
  tournamentId: null,
};

const tournamentPlayersSlice = createSlice({
  name: 'tournamentPlayers',
  initialState,
  reducers: {
    setTournamentPlayers: (state, action: PayloadAction<Players[]>) => {
      return {
        ...state,
        players: action.payload,
      };
    },
    setTournamentId: (state, action: PayloadAction<number>) => {
      return {
        ...state,
        tournamentId: action.payload,
      };
    },
  },
});

export const { setTournamentPlayers, setTournamentId } =
  tournamentPlayersSlice.actions;
export default tournamentPlayersSlice.reducer;
